"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DxcHeading = function DxcHeading(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? "" : _ref$text,
      as = _ref.as,
      weight = _ref.weight,
      margin = _ref.margin;
  var colorsTheme = (0, _useTheme["default"])();

  var checkValidAs = function checkValidAs() {
    if (as === "h1" || as === "h2" || as === "h3" || as === "h4" || as === "h5") return as;
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.heading
  }, /*#__PURE__*/_react["default"].createElement(HeadingContainer, {
    margin: margin
  }, level === 1 ? /*#__PURE__*/_react["default"].createElement(HeadingLevel1, {
    as: checkValidAs(),
    weight: weight
  }, text) : level === 2 ? /*#__PURE__*/_react["default"].createElement(HeadingLevel2, {
    as: checkValidAs(),
    weight: weight
  }, text) : level === 3 ? /*#__PURE__*/_react["default"].createElement(HeadingLevel3, {
    as: checkValidAs(),
    weight: weight
  }, text) : level === 4 ? /*#__PURE__*/_react["default"].createElement(HeadingLevel4, {
    as: checkValidAs(),
    weight: weight
  }, text) : /*#__PURE__*/_react["default"].createElement(HeadingLevel5, {
    as: checkValidAs(),
    weight: weight
  }, text)));
};

var HeadingContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
});

var HeadingLevel1 = _styledComponents["default"].h1(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  margin: 0;\n"])), function (props) {
  return props.theme.level1FontFamily;
}, function (props) {
  return props.theme.level1FontStyle;
}, function (props) {
  return props.theme.level1FontSize;
}, function (props) {
  return props.theme.level1LineHeight;
}, function (props) {
  return props.weight === "normal" ? "400" : props.weight === "light" ? "300" : props.weight === "bold" ? "600" : props.theme.level1FontWeight;
}, function (props) {
  return props.theme.level1LetterSpacing;
}, function (props) {
  return props.theme.level1FontColor;
});

var HeadingLevel2 = _styledComponents["default"].h2(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  margin: 0;\n"])), function (props) {
  return props.theme.level2FontFamily;
}, function (props) {
  return props.theme.level2FontStyle;
}, function (props) {
  return props.theme.level2FontSize;
}, function (props) {
  return props.theme.level2LineHeight;
}, function (props) {
  return props.weight === "normal" ? "400" : props.weight === "light" ? "300" : props.weight === "bold" ? "600" : props.theme.level2FontWeight;
}, function (props) {
  return props.theme.level2LetterSpacing;
}, function (props) {
  return props.theme.level2FontColor;
});

var HeadingLevel3 = _styledComponents["default"].h3(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  margin: 0;\n"])), function (props) {
  return props.theme.level3FontFamily;
}, function (props) {
  return props.theme.level3FontStyle;
}, function (props) {
  return props.theme.level3FontSize;
}, function (props) {
  return props.theme.level3LineHeight;
}, function (props) {
  return props.weight === "normal" ? "400" : props.weight === "light" ? "300" : props.weight === "bold" ? "600" : props.theme.level3FontWeight;
}, function (props) {
  return props.theme.level3LetterSpacing;
}, function (props) {
  return props.theme.level3FontColor;
});

var HeadingLevel4 = _styledComponents["default"].h4(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  margin: 0;\n"])), function (props) {
  return props.theme.level4FontFamily;
}, function (props) {
  return props.theme.level4FontStyle;
}, function (props) {
  return props.theme.level4FontSize;
}, function (props) {
  return props.theme.level4LineHeight;
}, function (props) {
  return props.weight === "normal" ? "400" : props.weight === "light" ? "300" : props.weight === "bold" ? "600" : props.theme.level4FontWeight;
}, function (props) {
  return props.theme.level4LetterSpacing;
}, function (props) {
  return props.theme.level4FontColor;
});

var HeadingLevel5 = _styledComponents["default"].h5(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  color: ", ";\n  margin: 0;\n"])), function (props) {
  return props.theme.level5FontFamily;
}, function (props) {
  return props.theme.level5FontStyle;
}, function (props) {
  return props.theme.level5FontSize;
}, function (props) {
  return props.theme.level5LineHeight;
}, function (props) {
  return props.weight === "normal" ? "400" : props.weight === "light" ? "300" : props.weight === "bold" ? "600" : props.theme.level5FontWeight;
}, function (props) {
  return props.theme.level5LetterSpacing;
}, function (props) {
  return props.theme.level5FontColor;
});

var _default = DxcHeading;
exports["default"] = _default;